import { FilePlus, Sparkles } from 'lucide-react';
import { useState } from 'react';

import { useRequestBlankSlide } from './BlankSlideInsertContext';
import { SuggestSlideDialog } from './SuggestSlideDialog';

export function SlideSeparator({ insertAtIndex }: { insertAtIndex: number }) {
  const [open, setOpen] = useState(false);
  const { requestNewSlide } = useRequestBlankSlide();

  return (
    <>
      <div className="group/sep relative -my-4 flex items-center justify-center gap-2 py-4">
        <div className="absolute inset-x-0 top-1/2 h-px border-t border-dashed border-border" />
        <button
          onClick={() => requestNewSlide(insertAtIndex)}
          className="relative inline-flex items-center gap-1.5 rounded-full border border-dashed border-border bg-bg px-4 py-1.5 text-[12px] font-medium text-fg-muted transition hover:border-accent hover:bg-white hover:text-accent hover:shadow-pill"
          title="Insert a blank or template slide here"
        >
          <FilePlus size={12} />
          New slide
        </button>
        <button
          onClick={() => setOpen(true)}
          className="relative inline-flex items-center gap-1.5 rounded-full border border-dashed border-accent/40 bg-bg px-4 py-1.5 text-[12px] font-medium text-accent transition hover:border-accent hover:bg-white hover:shadow-pill"
          title="Generate the next slide with AI"
        >
          <Sparkles size={12} />
          AI Suggest next slide
        </button>
      </div>

      <SuggestSlideDialog
        open={open}
        onClose={() => setOpen(false)}
        insertAtIndex={insertAtIndex}
      />
    </>
  );
}
